"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Add_1 = require("@material-ui/icons/Add");
const Remove_1 = require("@material-ui/icons/Remove");
const React = require("react");
const ArcadeCurrency_1 = require("../card/ArcadeCurrency");
const styles = (theme) => (0, core_1.createStyles)({
    content: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
        width: 200
    },
    text: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const WagerQuantity = ({ items, onUpdate, defaultIndex, classes }) => {
    const [index, setIndex] = React.useState(defaultIndex ? defaultIndex : 0);
    const onAdd = () => {
        if (index === items.length - 1)
            return;
        setIndex(index + 1);
        onUpdate(index + 1);
    };
    const onRemove = () => {
        if (index === 0)
            return;
        setIndex(index - 1);
        onUpdate(index - 1);
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: 'contained', color: 'secondary', onClick: onRemove, "aria-label": "remove", disabled: index === 0 }, { children: (0, jsx_runtime_1.jsx)(Remove_1.default, {}) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.text }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "subtitle1", color: "primary" }, { children: items[index] })), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 18 })] })), (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ variant: 'contained', color: 'secondary', onClick: onAdd, "aria-label": "add", disabled: index === items.length - 1 }, { children: (0, jsx_runtime_1.jsx)(Add_1.default, {}) }))] })));
};
exports.default = (0, styles_1.withStyles)(styles)(WagerQuantity);
//# sourceMappingURL=WagerQuantity.js.map